export enum ProductType {
  ALL = 'ALL',
  LOAN = 'LOAN',
  ORDER = 'ORDER',
}
